import React, { useState, useEffect, useMemo } from "react";
import Pagination from "../../Config/Pagination";
import { API_BASE_CRM_URL } from "../../Config/Config";
import { Link, useNavigate } from "react-router-dom";
import "../../Config/search.css";
import "../../Config/loader.css";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import "../../Config/loading.css";
import { useLabelContext } from "../../../Context";
import Base from "../../Config/Base";
import { Footer } from "../footer/footer";
import Swal from "sweetalert2";
import axios from "axios";

export default function CorporateLeads() {
  const navigate = useNavigate();

  const [leadsData, setLeadsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [contactLeadOBJ, setContactLeadOBJ] = useState([]);
  const [remidnerLeadOBJ, setRemidnerLeadOBJ] = useState([]);
  const { setID } = useLabelContext();
  const [leadCounts, setLeadCounts] = useState({
    activeLeads: 0,
    totalLeads: 0,
    reminders: 0,
    proposals: 0,
  });
  useEffect(() => {
    const userDetails = sessionStorage.getItem("userDetails");
    if (!userDetails) {
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${API_BASE_CRM_URL}leads/GetLeads`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();

        if (data.Status) {
          setLeadsData(data.ResultData);
        } else {
          console.error("Fetched data is not an array:", data);
          setLeadsData([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    getLeadCounts();
  }, []);

  const getLeadCounts = async () => {
    try {
      const response = await fetch(`${API_BASE_CRM_URL}leads/GetLeadCounts`);

      const result = await response.json();

      if (result.Status && result.ResultData.length > 0) {
        const counts = result.ResultData[0];

        setLeadCounts({
          activeLeads: counts.ActiveLeads,
          totalLeads: counts.TotalLeads,
          reminders: counts.Reminders,
          proposals: counts.Proposals,
        });
      }
    } catch (error) {
      console.error("Error fetching lead counts:", error);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);

    // Extract day, month, and year
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    // Format as dd-mm-yyyy
    return `${day}-${month}-${year}`;
  };

  const showContactModal = (obj) => {
    setContactLeadOBJ(obj);
  };

  const showReminderModal = (obj) => {
    setRemidnerLeadOBJ(obj);
  };

  const itemsPerPage = 12;

  const filteredItems = useMemo(() => {
    const results = leadsData.filter(
      (item) =>
        item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.company.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.phonenumber.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (item.source_name &&
          item.source_name.toLowerCase().includes(searchTerm.toLowerCase())),
    );

    setCurrentPage(1);

    return results;
  }, [leadsData, searchTerm]);

  // Calculate indices for slicing data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleExcelDownload = () => {
    if (leadsData.length === 0) return;

    const wb = XLSX.utils.book_new();

    // ===== HEADERS =====
    const headers = [["S.No", "Name", "Email", "Phone", "City", "Source"]];

    // ===== DATA =====
    const data = leadsData.map((item, index) => [
      index + 1, // Serial Number
      item.name,
      item.email,
      item.phonenumber,
      item.city,
      item.SourceName,
    ]);

    // Combine headers + data
    const wsData = [...headers, ...data];

    // Create worksheet
    const ws = XLSX.utils.aoa_to_sheet(wsData);

    // Optional column widths
    ws["!cols"] = [
      { wch: 8 }, // S.No
      { wch: 20 }, // Name
      { wch: 30 }, // Email
      { wch: 15 }, // Phone
      { wch: 15 }, // City
      { wch: 20 }, // Source
    ];

    // Append & save
    XLSX.utils.book_append_sheet(wb, ws, "Leads Data");
    XLSX.writeFile(wb, "IndividualLeadsData.xlsx");
  };

  const handlePDFDownload = () => {
    const doc = new jsPDF();

    // PDF metadata
    doc.setProperties({
      title: "Individual Leads Data",
    });

    // ===== TITLE =====
    const title = "Individual Leads Data";
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    doc.text(title, doc.internal.pageSize.getWidth() / 2, 15, {
      align: "center",
    });

    const startY = 25;

    // ===== HEADERS =====
    const headers = ["S.No", "Name", "Email", "Phone", "City", "Source"];

    // ===== BODY WITH SERIAL NUMBER =====
    const tableData = leadsData.map((item, index) => [
      index + 1, // ✅ Serial Number
      item.name,
      item.email,
      item.phonenumber,
      item.city,
      item.SourceName,
    ]);

    // ===== TABLE =====
    doc.autoTable({
      head: [headers],
      body: tableData,
      startY,
      styles: {
        fontSize: 10,
        halign: "center",
      },
      headStyles: {
        fillColor: [41, 128, 185],
        textColor: 255,
        halign: "center",
      },
    });

    doc.save("IndividualLeadsData.pdf");
  };

  const handleReload = () => {
    window.location.reload();
  };

  const handleViewPurchaseOrders = (item) => {
    console.log(item);
    setID(item.id);
    sessionStorage.setItem("leadType", item.vat);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };
  console.log(leadsData);

  const getSourceIcon = (sourceName) => {
    switch (sourceName?.toLowerCase()) {
      case "google":
        return "fab fa-google";

      case "facebook":
        return "fab fa-facebook-f";

      case "instagram":
        return "fab fa-instagram";

      case "website":
        return "fa-solid fa-globe";

      case "referal":
      case "referral":
        return "fa-solid fa-user-group";

      case "India Mart":
        return "fa-solid fa-handshake";

      case "BNI":
        return "fa-solid fa-gem";

      case "others":
      default:
        return "fa-solid fa-share-nodes";
    }
  };

  const [locationLoading, setLocationLoading] = useState(false);
  const [locationLeadId, setLocationLeadId] = useState(null);

  const handleAddLocation = (leadId) => {
    if (!navigator.geolocation) {
      Swal.fire({
        icon: "error",
        title: "Location Not Supported",
        text: "Geolocation is not supported by your browser.",
        confirmButtonColor: "#1B2850",
      });
      return;
    }
    const userDetailsSession = JSON.parse(
      sessionStorage.getItem("userDetails"),
    );
    setLocationLoading(true);
    setLocationLeadId(leadId);

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;

        const googleMapsUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;

        const payload = {
          rel_id: leadId,
          rel_type: "Lead",
          description: googleMapsUrl,
          addedfrom: userDetailsSession.staffid,
        };

        try {
          const response = await axios.post(
            `${API_BASE_CRM_URL}notes/AddNote`,
            payload,
          );

          if (response.data.Status) {
            Swal.fire({
              icon: "success",
              title: "Success",
              text: response.data.Message,
              confirmButtonColor: "#1B2850",
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Failed",
              text: response.data.Message || "Failed to add location.",
              confirmButtonColor: "#1B2850",
            });
          }
        } catch (error) {
          console.error("Error adding location:", error);

          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Something went wrong while adding the location.",
            confirmButtonColor: "#1B2850",
          });
        } finally {
          setLocationLoading(false);
          setLocationLeadId(null);
        }
      },
      (error) => {
        setLocationLoading(false);
        setLocationLeadId(null);

        let errorMessage = "Unable to retrieve your current location.";

        if (error.code === error.PERMISSION_DENIED) {
          errorMessage =
            "Location permission denied. Please allow location access.";
        } else if (error.code === error.POSITION_UNAVAILABLE) {
          errorMessage = "Location information is unavailable.";
        } else if (error.code === error.TIMEOUT) {
          errorMessage = "Location request timed out. Please try again.";
        }

        Swal.fire({
          icon: "error",
          title: "Location Error",
          text: errorMessage,
          confirmButtonColor: "#1B2850",
        });
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      },
    );
  };

  return (
    <Base>
      <div className="">
        <div className="d-flex justify-content-between">
          <div className="page-title">
            <h4>Leads</h4>
            <h6>Manage your Leads</h6>
          </div>
          <div>
            <ul className="d-inline-flex list-unstyled gap-1 mb-0 justify-content-end">
              <li>
                <a
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="PDF"
                  onClick={handlePDFDownload}
                  className="btn btn-light btn-sm px-0"
                >
                  {/* <img src="assets/img/icons/pdf.svg" alt="PDF" /> */}
                  <i
                    className="fa-solid fa-file-pdf fa-2xl"
                    style={{ color: "#ff0000" }}
                  ></i>
                </a>
              </li>
              <li>
                <a
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Excel"
                  onClick={handleExcelDownload}
                  className="btn btn-light btn-sm "
                >
                  {/* <img src="assets/img/icons/excel.svg" alt="Excel" /> */}
                  <i
                    className="fa-solid fa-file-excel fa-2xl"
                    style={{ color: "#217346" }}
                  ></i>
                </a>
              </li>
              <li>
                <Link
                  to="/add-lead"
                  className="btn btn btn-sm"
                  style={{ backgroundColor: "#1B2850" }}
                >
                  <i
                    className="fa-solid fa-plus"
                    style={{ color: "white" }}
                  ></i>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="row g-3 align-items-center my-2">
        <div className="col-4 m-0">
          <div
            className="card shadow text-center mb-2"
            style={{ borderRadius: "15px" }}
          >
            <div className="card-body">
              <p className="card-title mb-2">
                <i className="fa-solid fa-users fa-lg text-success"></i>
              </p>
              <h5 className="card-text fw-bold text-success">
                {leadCounts.activeLeads}/{leadCounts.totalLeads}
              </h5>
              <p className="small text-muted">Active</p>
            </div>
          </div>
        </div>

        <div className="col-4 m-0">
          <div
            className="card shadow text-center mb-2"
            style={{ borderRadius: "15px" }}
          >
            <div className="card-body">
              <p className="card-title mb-2">
                <i className="fa-solid fa-comments fa-lg text-warning"></i>
              </p>
              <h5 className="card-text fw-bold text-warning">
                {leadCounts.reminders}
              </h5>
              <p className="small text-muted mb-0 text-nowrap">Reminders</p>
            </div>
          </div>
        </div>

        <div className="col-4 m-0">
          <div
            className="card shadow text-center mb-2"
            style={{ borderRadius: "15px" }}
          >
            <div className="card-body">
              <p className="card-title mb-2">
                <i className="fa-solid fa-file-signature fa-lg text-secondary"></i>
              </p>
              <h5 className="card-text fw-bold text-secondary">
                {leadCounts.proposals}
              </h5>
              <p className="small text-muted">Proposals</p>
            </div>
          </div>
        </div>
      </div>
      <div className="col-12 mb-3">
        <div className="input-group">
          <input
            type="text"
            name="search"
            placeholder="Search..."
            className="form-control"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <span className="input-group-text bg-primary" id="basic-addon1">
            <i className="fa-solid fa-magnifying-glass"></i>
          </span>
        </div>
      </div>

      <div className="card-container mb-5">
        {loading ? (
          <div className="containers m-auto">
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
          </div>
        ) : (
          <div className="row g-2 mb-2">
            {currentItems.map((item, index) => (
              <div key={index} className="col-12 col-md-6 col-lg-4">
                <div className="card mb-2 rounded-4">
                  <div className="card-body">
                    <h5 className=" d-flex justify-content-between align-items-center mb-2">
                      <Link
                        className="d-flex align-items-center"
                        to={`/view-lead/${item.id}`}
                        onClick={() => handleViewPurchaseOrders(item)}
                        state={{ activeTab: "profile" }}
                      >
                        <div
                          style={{
                            width: "55px",
                            height: "55px",
                            borderRadius: "50%",
                            backgroundColor: "#E3F2FD",
                            color: "#0A1F3E",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontWeight: "bold",
                            marginRight: "8px",
                            textTransform: "uppercase",
                          }}
                        >
                          {item?.name?.trim()
                            ? item.name.trim().substring(0, 2)
                            : "NA"}
                        </div>
                        <div className="d-flex flex-column">
                          <div>{item?.name || "N/A"}</div>
                          <div className="d-flex">
                            <i className="fa-solid fa-location-dot me-2"></i>
                            {item.city}
                          </div>
                        </div>
                      </Link>

                      <div className="dropdown">
                        <a
                          className="action-set"
                          href="#"
                          data-bs-toggle="dropdown"
                        >
                          <i className="fas fa-ellipsis-v fs-5"></i>
                        </a>

                        <div className="dropdown-menu">
                          <Link
                            to={`/view-lead/${item.id}`}
                            className="dropdown-item"
                            onClick={() => handleViewPurchaseOrders(item)}
                            state={{ activeTab: "profile" }}
                          >
                            <i className="fas fa-eye me-2"></i>
                            View
                          </Link>

                          {/* <Link
                            to="/view-lead"
                            className="dropdown-item"
                            onClick={() => handleViewPurchaseOrders(item)}
                            state={{ leadData: item,
                              activeTab: " AddContact", }}
                          >
                              <i className="fas fa-address-book me-2"></i>
                            Add Contact
                          </Link> */}

                          <Link
                            to={`/view-lead/${item.id}`}
                            className="dropdown-item"
                            onClick={() => handleViewPurchaseOrders(item)}
                            state={{ activeTab: "reminders" }}
                          >
                            <i className="fas fa-clock me-2"></i>
                            Set Follow-Ups
                          </Link>

                          <Link
                            to={`/view-lead/${item.id}`}
                            className="dropdown-item"
                            onClick={() => handleViewPurchaseOrders(item)}
                            state={{ activeTab: "proposals" }}
                          >
                            <i className="fas fa-file-signature me-2"></i>
                            Proposal
                          </Link>

                          <Link
                            to={`/view-lead/${item.id}`}
                            className="dropdown-item"
                            state={{ activeTab: "notes" }}
                          >
                            <i className="fa-regular fa-note-sticky me-2"></i>
                            Notes
                          </Link>

                          <button
                            type="button"
                            className="dropdown-item"
                            onClick={() => handleAddLocation(item.id)}
                            disabled={
                              locationLoading && locationLeadId === item.id
                            }
                          >
                            {locationLoading && locationLeadId === item.id ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm me-2"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                Adding Location...
                              </>
                            ) : (
                              <>
                                <i className="fa-solid fa-location-dot me-2"></i>
                                Add Location
                              </>
                            )}
                          </button>
                        </div>
                      </div>
                    </h5>

                    <div className="card-details">
                      <div className="row g-2">
                        <div className="col-8">
                          <span className=" d-block">
                            <i
                              className="fa-solid fa-building me-2"
                              style={{ color: "#1B2850" }}
                            ></i>
                            {item.company}
                          </span>
                        </div>

                        <div className="col-4">
                          <span className="d-block">
                            <i
                              className={`${getSourceIcon(item.SourceName)} me-1`}
                              style={{ color: "#1B2850" }}
                            ></i>
                            {item.SourceName || "N/A"}
                          </span>
                        </div>

                        <div className="col-7">
                          <a
                            href={`mailto:${item.email}`}
                            className="d-block text-truncate text-decoration-none"
                            style={{ color: "inherit" }}
                            onClick={(e) => e.stopPropagation()}
                          >
                            <i
                              className="fa-solid fa-envelope me-1"
                              style={{ color: "#1B2850" }}
                            ></i>
                            {item.email}
                          </a>
                        </div>

                        <div className="col-5">
                          <span className=" d-flex align-items-center">
                            <a
                              href={`tel:${item.phonenumber}`}
                              className="me-2"
                            >
                              <i className="fa-solid fa-phone"></i>
                            </a>

                            <a
                              href={`https://wa.me/${item.phonenumber?.replace(
                                /\D/g,
                                "",
                              )}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="me-2"
                            >
                              {item.phonenumber}
                              <i
                                className="fa-brands fa-whatsapp fa-lg ms-2"
                                style={{ color: "#25D366" }}
                              ></i>
                            </a>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="">
          <Pagination
            itemsPerPage={itemsPerPage}
            totalItems={filteredItems.length}
            paginate={paginate}
            currentPage={currentPage}
          />
        </div>
      </div>

      <Footer></Footer>
    </Base>
  );
}
